module.exports = __webpack_public_path__ + "static/building-our-future-2d4748195db7a5eb76f941e7d1ded719.png";